import Switch from "../Switch";

function OcpiModulesList({
    modules,
    selected = [],
    onChange,
    disabled = false,
}) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
            {modules.map((module) => {
                const isOn = selected.includes(module.value);

                return (
                    <div
                        key={module.value}
                        className="flex items-center justify-between gap-3 py-3 border-b border-mute-200 min-w-0"
                    >
                        <span className="text-sm text-mute-700">{module.label}</span>
                        <Switch
                            checked={isOn}
                            disabled={disabled}
                            onChange={(on) => {
                                const next = on
                                    ? isOn
                                        ? selected
                                        : [...selected, module.value]
                                    : selected.filter((m) => m !== module.value);
                                onChange(next);
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
}

export default OcpiModulesList;
